import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-calendar-icon',
  templateUrl: './calendar-icon.component.html',
  styleUrls: ['./calendar-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
